import { ExpandLess, ExpandMore } from "@material-ui/icons";
import React, { useState } from "react";
import { displayBalance, displayBalanceFloat, displayNDC } from "../../../utils/Helpers";

// positive first, negative second, zero third
const sortTier = (num) => (num > 0 ? 1 : num < 0 ? 2 : 3);

const transactionSort = (a, b) => {
  if (sortTier(b.purchase_count) !== sortTier(a.purchase_count)) {
    return sortTier(a.purchase_count) - sortTier(b.purchase_count);
  }

  if (b.purchase_count !== a.purchase_count) {
    return b.purchase_count - a.purchase_count;
  }

  if (b.purchase_units !== a.purchase_units) {
    return b.purchase_units - a.purchase_units;
  }

  if (b.claim_units !== a.claim_units) {
    return b.claim_units - a.claim_units;
  }

  return String(a.ndc).localeCompare(String(b.ndc), undefined, { numeric: true });
};

export const MonthlyTransactionRow = ({ monthlyTransaction }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div
        className={`${expanded ? "bg--light-navy " : " "}row align-items-center bg--white row-border-bottom h--48`}
        key={monthlyTransaction.month}
      >
        <div className="col col-1">
          <button className="btn btn--sqr" onClick={() => setExpanded(!expanded)}>
            {expanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
          </button>
        </div>
        <div className="col t--500">{monthlyTransaction.month}</div>
        <div className="col">{displayBalance(monthlyTransaction.purchase_count)}</div>
        <div className="col">{displayBalanceFloat(monthlyTransaction.purchase_units)}</div>
        <div className="col">{displayBalanceFloat(monthlyTransaction.claim_units)}</div>
      </div>
      {expanded ? (
        <div>
          {monthlyTransaction.transactions.sort(transactionSort).map((transaction) => (
            <div
              className="row align-items-center border--bottom"
              style={{ height: 38 }}
              key={transaction.ndc_11}
            >
              <div className="col col-1"></div>
              <div className="col t--500">{displayNDC(transaction.ndc_11)}</div>
              <div className="col">{displayBalance(transaction.purchase_count)}</div>
              <div className="col">{displayBalanceFloat(transaction.purchase_units)}</div>
              <div className="col">{displayBalanceFloat(transaction.claim_units)}</div>
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};
